import React, { ReactNode } from 'react';

export interface TwilioErrorBoundaryProps {
  FallbackComponent?: ReactNode;
}

class TwilioErrorBoundary extends React.Component<TwilioErrorBoundaryProps, { hasError: boolean }> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { FallbackComponent } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      return FallbackComponent ?? <div />;
    }
    const { children } = this.props;
    return children;
  }
}

export default TwilioErrorBoundary;
